/**
 * First argument is `target`, that is contract address to execute on.
 * Second argument is `data`, that is encoded contract method.
 */
export type TronCall = [string, string];
